$(document).ready(function () {
  $(document).on("click", ".btn_toggle", function () {
    var $current = $(this);
    var $currentWrapper = $current.next(".product_options_wrapper");
    var $siblings = $current
      .parents(".product-card-wrapper")
      .siblings(".product-card-wrapper");

    // Disable clicks during animation
    if ($current.data("animating")) return;
    $current.data("animating", true);

    // First close all siblings
    var $openSiblings = $siblings.find(".product_options_wrapper:visible");
    if ($openSiblings.length) {
      $openSiblings.slideUp(function () {
        $siblings.find(".btn_toggle").removeClass("open");

        // After siblings are closed, open current one
        toggleCurrent();
      });
    } else {
      // If no siblings are open, directly open current
      toggleCurrent();
    }

    function toggleCurrent() {
      if ($currentWrapper.is(":visible")) {
        // If already open, just close it
        $currentWrapper.slideUp(function () {
          $current.removeClass("open");
          $current.removeData("animating");
        });
      } else {
        // Open current
        $current.addClass("open");
        $currentWrapper.slideDown(function () {
          $current.removeData("animating");
        });
      }
    }
    var popupContent = $("#cart-notification");
    setTimeout(function () {
      popupContent.scrollTop(popupContent[0].scrollHeight);
    }, 400);
  });

  $(document).on(
    "change",
    ".card-product-radio .input-type-radio",
    function () {
      $(this)
        .parents(".active-product")
        .find(".product-form__submit")
        .removeClass("disabled");
      const allVariants = JSON.parse(
        $(this)
          .parents("fieldset")
          .siblings('[type="application/json"]')
          .text() || "[]"
      );
      const fieldsets = Array.from($(this).parents("fieldset"));
      const options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
      const currentVariant = allVariants.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return options[index] === option;
          })
          .includes(false);
      });
      currentVariant.id &&
        $(this)
          .parents(".active-product")
          .find('product-form [name="id"]')
          .val(currentVariant.id);
    }
  );

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".product-card-wrapper").length) {
      $(".product_options_wrapper:visible").slideUp(function () {
        $(".btn_toggle.open").removeClass("open");
      });
    }
  });

  $(document).on("click", ".cart-notification__links .close_btn", function () {
    $(".modal__close-button").trigger("click");
  });
});
